import gql from 'graphql-tag';

export default gql`
mutation(
  $isPublished: Boolean!, 
  $hasChanged: Boolean!, 
  $publishButtonIsPressed: Boolean!,
  $hasParentProject: Boolean!,
  $parentProjectIsPublished: Boolean!
) {
  setPageHasToBePublished(
    isPublished: $isPublished
    hasChanged: $hasChanged
    publishButtonIsPressed: $publishButtonIsPressed
    hasParentProject: $hasParentProject
    parentProjectIsPublished: $parentProjectIsPublished
  ) @client
}
`;
